import React from 'react';

import {
  Box,
  Code,
  HStack,
  Link,
  List,
  ListItem,
  Text,
} from '@chakra-ui/react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { customTheme } from 'theme';

interface Props {
  onClickLink?: (id: string, type: string) => void;
  content: string;
}

export const ChakraMarkdown = (props: Props) => {
  const { content } = props;

  return (
    <Markdown
      remarkPlugins={[remarkGfm]}
      components={{
        h1: ({ children }) => (
          <Text fontWeight={600} as="h1" size="xl" my={4}>
            {children}
          </Text>
        ),
        h2: ({ children }) => (
          <Text fontWeight={600} as="h2" size="lg" my={3}>
            {children}
          </Text>
        ),
        h3: ({ children }) => (
          <Text fontWeight={600} as="h3" size="md" my={2}>
            {children}
          </Text>
        ),
        p: ({ children }) => <Text mb={2}>{children}</Text>,
        a: ({ href, children }) => (
          <Link href={href} color="primary" isExternal>
            {children}
          </Link>
        ),
        code: ({ children }) => (
          <Code
            colorScheme={customTheme.colors.gray['100']}
            p={1}
            borderRadius="md"
          >
            {children}
          </Code>
        ),
        ul: ({ children, node }) => {
          // console.log(filter(node?.children, o => o?.tagName === 'li'));
          return (
            <List styleType="disc" pb={3} spacing={2} pl={4}>
              {children}
            </List>
          );
        },
        ol: ({ children }) => (
          <List styleType="decimal" spacing={2} pb={2} pl={4}>
            {children}
          </List>
        ),
        li: ({ node, children }) => {
          return (
            <ListItem pl={3}>
              {/*{children?.[0]?.props?.children === 'ARN:' ||
              children?.[0]?.props?.children === 'Resource ID:' ? (
                <HStack spacing={1}>
                  <Box fontWeight={600}>{children?.[0]?.props?.children}</Box>
                  <Text
                    onClick={() => {
                      console.log(extractText(children?.[1]),
                        children?.[0]?.props?.children === 'ARN:'
                          ? 'arn'
                          : 'id')
                      onClickLink?.(
                        extractText(children?.[1]),
                        children?.[0]?.props?.children === 'ARN:'
                          ? 'arn'
                          : 'id',
                      );
                    }}
                    color="primary"
                    cursor="pointer"
                    textDecoration="underline"
                  >
                    {children?.[1]}
                  </Text>
                </HStack>
              ) : (
                children
              )}*/}
              {children}
            </ListItem>
          );
        },
      }}
    >
      {content}
    </Markdown>
  );
};

export default ChakraMarkdown;
